'use client';

import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { LOADING_ITEM_COUNT } from './visibleItems';

export type RecoCarouselLoadingListProps = {
  type?: 'CAT' | 'PRODUCT' | 'BRAND';
  className?: string;
};

const getHeight = (type: RecoCarouselLoadingListProps['type']) => {
  switch (type) {
    case 'CAT':
      return 'h-[220px]';
    case 'BRAND':
      return 'h-[130px]';
    case 'PRODUCT':
    default:
      return 'h-[300px]';
  }
};

export const RecoCarouselLoadingList = ({ type, className }: RecoCarouselLoadingListProps) => (
  <div
    className={`grid auto-cols-[min(calc((100%-(var(--items-visible)-1)*var(--reco-gap))/var(--items-visible)),var(--card-max,100%))] grid-flow-col gap-(--reco-gap) gap-x-1.5 overflow-hidden ${className}`}
  >
    {Array.from({ length: LOADING_ITEM_COUNT }).map((_, index) => (
      <Skeleton
        // eslint-disable-next-line @eslint-react/no-array-index-key
        key={index}
        className={`${getHeight(type)} rounded-sm`}
      />
    ))}
  </div>
);
